module.exports = __webpack_public_path__ + "img/Zsuzsi_Simon_Alexandru_10.c0e346a5.jpg";